"use client";

import React from "react";
import {getFileTypeIcon} from "@/utils/fileHelpers";
import type {FileTypeInfo} from "@/utils/fileTypeDetection";
import PdfThumbnail from "../common/PdfThumbnail";
import DocxThumbnail from "../common/DocxThumbnail";
import ExcelThumbnail from "../common/ExcelThumbnail";
import Icon, {ICON_SIZES} from "../library/Icon";

const FileAttachmentThumbnail: React.FC<{
   fileType: FileTypeInfo;
   objectUrl: string | null;
   excelData: string[][] | null;
   file: File;
}> = ({fileType, objectUrl, excelData, file}) => {
   if (fileType.isImage && objectUrl) {
      return <img src={objectUrl} alt={file.name} className="w-full h-full object-cover" />;
   }
   if (fileType.isPdf && objectUrl) {
      return <PdfThumbnail file={objectUrl} width={140} />;
   }
   if (fileType.isDocx && objectUrl) {
      return <DocxThumbnail url={objectUrl} />;
   }
   if (fileType.isExcel && excelData) {
      return <ExcelThumbnail data={excelData} fontSize="text-[6px]" maxCellWidth="max-w-[40px]" />;
   }
   return <Icon icon={getFileTypeIcon(file.name, file.type)} size={ICON_SIZES.XL} className="text-400" />;
};

export default FileAttachmentThumbnail;
